module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "sec-6"
    }
  }, [_c('p', {
    staticClass: "noindent1",
    staticStyle: {
      "margin-top": "4em"
    },
    attrs: {
      "id": "pz6-6"
    }
  }, [_c('b', [_vm._v("DISCIPLESHIP IN COMMUNITY")]), _c('br'), _c('i', [_vm._v("A Theological Vision for the Future")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    staticStyle: {
      "text-align": "left",
      "margin-top": "0.5em"
    },
    attrs: {
      "id": "AVYo"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.png",
      "id": "AFc",
      "src": "images/himg-6-1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "Aj_"
    }
  }, [_vm._v("Copyright © 2020 by Mark E. Powell, John Mark Hicks, and Greg McKinzie")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "AUR"
    }
  }, [_vm._v("ISBN 978-1-68426-410-1 | LCCN 2019056910")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "A0O"
    }
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "A7n"
    }
  }, [_vm._v("ALL RIGHTS RESERVED"), _c('br'), _vm._v("No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form by any means—electronic, mechanical, photocopying, recording, or otherwise—without prior written consent.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2",
    attrs: {
      "id": "pz6-8"
    }
  }, [_vm._v("All scripture quotations, unless otherwise indicated, are taken from the Holy Bible, New International Version"), _c('sup', [_vm._v("®")]), _vm._v(", NIV"), _c('sup', [_vm._v("®")]), _vm._v(". Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.™ Used by permission of Zondervan. All rights reserved worldwide.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "AIW"
    }
  }, [_vm._v("LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA")]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "pz6-10"
    }
  }, [_vm._v("Names: Powell, Mark E., author. | Hicks, John Mark, author. | McKinzie, Greg, 1982- author.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "pz6-11"
    }
  }, [_vm._v("Title: Discipleship in community : a theological vision for the future / Mark E. Powell, John Mark Hicks and Greg McKinzie.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "pz6-12"
    }
  }, [_vm._v("Description: Abilene, Texas : Abilene Christian University Press, 2020. | Includes bibliographical references.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "pz6-13"
    }
  }, [_vm._v("Identifiers: LCCN 2019056910 | ISBN 9781684264100 (paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "Alj"
    }
  }, [_vm._v("Subjects: LCSH: Churches of Christ. | Christian life. | Theology, Doctrinal. | Christianity—21st century.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "AXy"
    }
  }, [_vm._v("Classification: LCC BX7076 .P69 2020 | DDC 230/.6634—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "copy1",
    attrs: {
      "id": "AWJ"
    }
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2019056910",
      "id": "AJ7R",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019056910")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "AYq"
    }
  }, [_vm._v("Cover design by ThinkPen Design"), _c('br'), _vm._v("Interior text design by Sandy Armstrong, Strong Design")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "Anx"
    }
  }, [_vm._v("For information contact:"), _c('br'), _vm._v("Abilene Christian University Press"), _c('br'), _vm._v("ACU Box 29138"), _c('br'), _vm._v("Abilene, Texas 79699")]), _vm._v(" "), _c('p', {
    staticClass: "copy",
    attrs: {
      "id": "AM-"
    }
  }, [_vm._v("1-877-816-4455"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.acupressbooks.com",
      "id": "A6Ix",
      "target": "_blank"
    }
  }, [_vm._v("www.acupressbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyc",
    attrs: {
      "id": "Ah4"
    }
  }, [_vm._v("20 21 22 23 24 25 26 / 7 6 5 4 3 2 1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a70f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyrightpage.vue
// module id = 66
// module chunks = 0